"use client";

import React, { useContext, useEffect } from "react";
import dynamic from "next/dynamic";

import { GridLandingModule } from "@/components/GridLandingModule";
import { TabsModule } from "@/components/TabsModule";
import { ReasonsModule } from "@/components/ReasonsModule";
import { BenefitsMoodule } from "@/components/BenefitsModule";
import { BannerWrapperSize } from "@/components/Banner/types";
import { useWindowSize } from "@/hooks/browser/useWindowsSize";
import { LayoutContext } from "@/contexts/LayoutContext";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";
import { LandingPageTemplateProps } from "./types";

import "./styles.scss";

const KeepItSimpleModule = dynamic(
  () =>
    import("@/components/KeepItSimpleModule").then(({ KeepItSimpleModule }) => KeepItSimpleModule),
  {
    ssr: false,
  }
);

export const LandingPageTemplate = ({ data }: LandingPageTemplateProps) => {
  const screenSize = useWindowSize();
  const { setIsQRLanding } = useContext(LayoutContext);
  const { setSource } = useContext(AmplitudeContext);

  const getWrapperSize = (isTablet: BannerWrapperSize, isNotTablet: BannerWrapperSize) => {
    return screenSize?.isTablet ? isTablet : isNotTablet;
  };

  useEffect(() => {
    setIsQRLanding(true);
  }, []);
  return (
    <main>
      <GridLandingModule
        wrapperSize={getWrapperSize("sm", "lg")}
        data={data.preview}
        defaultPreviewTitle={data.defaultPreviewTitle}
        previewTranslations={data?.previewTranslations}
      />
      <TabsModule
        data={{
          title: data.landingTabs.title,
          faqsHomeTabs: data.landingTabs.tabs,
          actionButton: data.landingTabs.actionButton,
          customClass: data.landingTabs.customClass || "",
          amplitudeEvent: data.landingTabs.amplitudeEvent,
        }}
        wrapperSize="md"
        backgroundColor={data.landingTabs.backgroundColor}
        className="landing-tabs"
        setSource={setSource}
      />
      <BenefitsMoodule
        data={data.landingBenefits}
        wrapperSize={getWrapperSize("sm", "lg")}
        setSource={setSource}
      />
      <ReasonsModule
        data={data.landingReasons}
        wrapperSize={getWrapperSize("sm", "lg")}
        setSource={setSource}
      />
      <KeepItSimpleModule
        data={data.banner}
        wrapperSize={getWrapperSize("sm", "lg")}
        setSource={setSource}
      />
    </main>
  );
};
